import React from 'react';
import { SHADCN, R, TYPO, S, FS } from '../theme';

if (typeof document !== 'undefined' && !document.getElementById('status-pill-pulse')) {
  const style = document.createElement('style');
  style.id = 'status-pill-pulse';
  style.textContent = `
    @keyframes statusPillPulse {
      0%   { box-shadow: 0 0 0 0 var(--pulse-color, currentColor); opacity: 1; }
      70%  { box-shadow: 0 0 0 6px transparent; opacity: 0.85; }
      100% { box-shadow: 0 0 0 0 transparent; opacity: 1; }
    }
  `;
  document.head.appendChild(style);
}

// ── <StatusPill> — Shadcn dark ──────────────────────────────────────────────
// Pastille de statut compacte : fond pastel + filet + texte de la couleur
// sémantique. Variants : success / warning / error / info / neutral.

const TONES = {
  success: { bg: 'oklch(0.871 0.15 154.449 / 0.12)',  border: 'oklch(0.871 0.15 154.449 / 0.35)', color: SHADCN.success, dot: SHADCN.success },
  warning: { bg: 'oklch(0.852 0.199 91.936 / 0.12)',  border: 'oklch(0.852 0.199 91.936 / 0.35)', color: SHADCN.warning, dot: SHADCN.warning },
  error:   { bg: 'oklch(0.577 0.245 27.325 / 0.15)',  border: 'oklch(0.577 0.245 27.325 / 0.4)',  color: SHADCN.error,   dot: SHADCN.error },
  info:    { bg: 'oklch(0.685 0.169 237.323 / 0.12)', border: 'oklch(0.685 0.169 237.323 / 0.35)', color: SHADCN.info,    dot: SHADCN.info },
  neutral: { bg: SHADCN.sidebarAccent,                 border: SHADCN.border,                       color: SHADCN.fg,      dot: SHADCN.mutedFg },
};

// Échelle unique partagée avec DeltaPill — 2 tailles, point.
//   sm : pills denses (listes, tableaux, badges secondaires)
//   md : pills autonomes (headers, statuts principaux) — défaut
const SIZES = {
  sm: { padding: '2px 8px',  fontSize: 11, dot: 5 },
  md: { padding: '4px 10px', fontSize: FS.xs, dot: 6 },
};

export default function StatusPill({ children, variant = 'neutral', size = 'md', tone, dot = false, style }) {
  const t = tone || TONES[variant] || TONES.neutral;
  const s = SIZES[size] || SIZES.md;
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      background: t.bg,
      border: `1px solid ${t.border}`,
      color: t.color,
      borderRadius: R.pill,
      padding: s.padding,
      ...TYPO.body,
      fontSize: s.fontSize,
      fontWeight: 500,
      lineHeight: 1.4,
      whiteSpace: 'nowrap',
      ...style,
    }}>
      {dot && <span style={{
        width: s.dot,
        height: s.dot,
        borderRadius: R.pill,
        background: t.dot || t.color,
        color: t.dot || t.color,
        animation: 'statusPillPulse 1.8s ease-out infinite',
      }} />}
      {children}
    </span>
  );
}
